import {
  SET_RECOVERY_MASKED_DATA,
  SET_RECOVERY_STEP,
  SET_RECOVERY_REQUESTID,
} from './types'

function setRecoveryMaskedData(recoveryMaskedData) {
  return {
    type: SET_RECOVERY_MASKED_DATA,
    payload: {
      recoveryMaskedData,
    },
  }
}

function setRecoveryStep(recoveryStep) {
  return {
    type: SET_RECOVERY_STEP,
    payload: {
      recoveryStep,
    },
  }
}

function setRecoveryRequestId(recoveryRequestId) {
  return {
    type: SET_RECOVERY_REQUESTID,
    payload: {
      recoveryRequestId,
    },
  }
}

export { setRecoveryMaskedData, setRecoveryStep, setRecoveryRequestId }
